export enum Errors {
    NoPageIdSupplied,
    InvalidPageId
}